import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M2.958 2.958a1.02 1.02 0 0 1 1.44 0l3.603 3.603 3.603-3.603a1.019 1.019 0 0 1 1.44 1.44L9.442 8.002l3.602 3.603a1.02 1.02 0 0 1-1.44 1.44L8 9.442 4.4 13.044a1.02 1.02 0 0 1-1.44-1.44L6.56 8 2.958 4.4a1.02 1.02 0 0 1 0-1.44"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })